import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { 
  Users, 
  Package, 
  ShoppingCart, 
  Clock,
  TrendingUp
} from "lucide-react";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/admin/stats`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
        setStats(res.data);
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <div className="ml-64 p-8 text-gray-500">Loading Stats...</div>;
  if (!stats) return <div className="ml-64 p-8 text-red-500">Error loading statistics. Please check the backend.</div>;

  const cards = [
    { name: "Total Users", value: stats.userCount, icon: <Users size={24} />, color: "bg-blue-500", path: "/admin/users" },
    { name: "Total Posts", value: stats.postCount, icon: <Package size={24} />, color: "bg-green-500", path: "/admin/posts" },
    { name: "Total Orders", value: stats.orderCount, icon: <ShoppingCart size={24} />, color: "bg-purple-500", path: "/admin/orders" },
    { name: "Pending Posts", value: stats.pendingPostCount, icon: <Clock size={24} />, color: "bg-amber-500", path: "/admin/posts" },
    { name: "Pending Orders", value: stats.pendingOrderCount, icon: <TrendingUp size={24} />, color: "bg-rose-500", path: "/admin/orders" },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="ml-64 p-8">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Dashboard Overview</h1>
          <p className="text-gray-500">Welcome to the WebHulu management console.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-8">
          {cards.map((card, i) => (
            <Link 
              key={i} 
              to={card.path} 
              className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-300 transform hover:-translate-y-1 group"
            >
              <div className={`${card.color} p-3 rounded-xl text-white transition-transform group-hover:scale-110 duration-300`}>
                {card.icon}
              </div>
              <div>
                <p className="text-sm text-gray-500 font-medium">{card.name}</p>
                <p className="text-2xl font-bold text-gray-900">{card.value}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* RECENT ACTIVITY PLACEHOLDERS */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
            <h2 className="text-xl font-bold mb-4">Quick Actions</h2>
            <div className="grid grid-cols-2 gap-4">
              <button className="p-4 bg-gray-50 rounded-xl text-left hover:bg-green-50 hover:text-green-600 transition-colors border border-transparent hover:border-green-100">
                <p className="font-bold">Review Posts</p>
                <p className="text-xs text-gray-500">Approve pending listings</p>
              </button>
              <button className="p-4 bg-gray-50 rounded-xl text-left hover:bg-blue-50 hover:text-blue-600 transition-colors border border-transparent hover:border-blue-100">
                <p className="font-bold">Manage Orders</p>
                <p className="text-xs text-gray-500">Track customer requests</p>
              </button>
            </div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-center text-gray-400">
            Charts coming soon...
          </div>
        </div>
      </main>
    </div>
  );
}
